import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateServiceProfile, UpdateServiceProfilePayload } from "../services/serviceProfile.service";
import { userKeys } from "../queryKeys";

interface UseUpdateServiceProfileMutationProps {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export const useUpdateServiceProfileMutation = ({ onSuccess, onError }: UseUpdateServiceProfileMutationProps = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ userId, payload }: { userId: string; payload: UpdateServiceProfilePayload }) =>
      updateServiceProfile(userId, payload),
    onSuccess: (_, variables) => {
      const userIdNumber = Number(variables.userId);
      // Invalidate service profile queries from GoService
      queryClient.invalidateQueries({ queryKey: ["go-hire", "service-profile", userIdNumber] });
      // Invalidate user profile queries
      queryClient.invalidateQueries({ queryKey: userKeys.profile(variables.userId) });
      onSuccess?.();
    },
    onError: (error: Error) => {
      onError?.(error);
    },
  });
};
